import { ActionReducer, combineReducers } from '@ngrx/store';

import { showRecessions } from 'TargetRatesApp/apps/target-rates-app/state/show-recessions/show-recessions.reducer';

import { TargetRatesState } from 'TargetRatesApp/interfaces/state.interface';

export const targetRates: ActionReducer<TargetRatesState> = combineReducers({
    showRecessions,
});
